import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
export function PrivacyPage() {
  return <div className="pt-32 pb-20 bg-white" data-id="element-388">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-389">
        <SectionHeading title="Privacy Policy" className="mb-12" data-id="element-390" />

        <div className="prose prose-slate lg:prose-lg" data-id="element-391">
          <p className="lead" data-id="element-392">Last updated: May 15, 2024</p>

          <h3 data-id="element-393">1. Introduction</h3>
          <p data-id="element-394">
            NexusFlow ("we", "our", or "us") is committed to protecting your
            privacy. This Privacy Policy explains how we collect, use, disclose,
            and safeguard your information when you visit our website or use our
            services.
          </p>

          <h3 data-id="element-395">2. Information We Collect</h3>
          <p data-id="element-396">
            We may collect information about you in a variety of ways. The
            information we may collect includes:
          </p>
          <ul data-id="element-397">
            <li data-id="element-398">
              <strong data-id="element-399">Personal Data:</strong> Personally identifiable
              information, such as your name, shipping address, email address,
              and telephone number.
            </li>
            <li data-id="element-400">
              <strong data-id="element-401">Derivative Data:</strong> Information our servers
              automatically collect when you access the Site, such as your IP
              address, your browser type, your operating system, your access
              times, and the pages you have viewed directly before and after
              accessing the Site.
            </li>
          </ul>

          <h3 data-id="element-402">3. Use of Your Information</h3>
          <p data-id="element-403">
            Having accurate information about you permits us to provide you with
            a smooth, efficient, and customized experience. Specifically, we may
            use information collected about you via the Site to:
          </p>
          <ul data-id="element-404">
            <li data-id="element-405">Create and manage your account.</li>
            <li data-id="element-406">Process your payments and refunds.</li>
            <li data-id="element-407">Send you a newsletter.</li>
            <li data-id="element-408">Email you regarding your account or order.</li>
          </ul>

          <h3 data-id="element-409">4. Disclosure of Your Information</h3>
          <p data-id="element-410">
            We may share information we have collected about you in certain
            situations. Your information may be disclosed as follows:
          </p>
          <ul data-id="element-411">
            <li data-id="element-412">
              <strong data-id="element-413">By Law or to Protect Rights:</strong> If we believe the
              release of information about you is necessary to respond to legal
              process, to investigate or remedy potential violations of our
              policies, or to protect the rights, property, and safety of
              others.
            </li>
          </ul>

          <h3 data-id="element-414">5. Contact Us</h3>
          <p data-id="element-415">
            If you have questions or comments about this Privacy Policy, please
            contact us at:
            <br data-id="element-416" />
            <a href="mailto:privacy@nexusflow.com" className="text-indigo-600 hover:underline" data-id="element-417">
              privacy@nexusflow.com
            </a>
          </p>
        </div>
      </div>
    </div>;
}